export const DEFAULT_MIN_LENGTH: number = 0;
export const DEFAULT_MAX_LENGTH: number = 255;
